import React from "react";
import { Outlet } from "react-router-dom";
import styled from "@emotion/styled";

import { CssBaseline } from "@mui/material";

import GlobalStyle from "@/components/GlobalStyle";

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

interface PresentationType {
  children?: React.ReactNode;
}

const Presentation: React.FC<PresentationType> = ({ children }) => {
  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <AppContent>
        {children}
        <Outlet />
      </AppContent>
    </Root>
  );
};

export default Presentation;
